export default {
  vouchers: 'Bons de réduction',
  voucher: 'Bon de réduction',
  'voucher.value': 'Valeur du bon {currency}',
  'vouchers.code': 'Code du bon',
  'vouchers.limit_usage': "Limitation d'utilisation",
  'vouchers.max_cart_price': 'Prix maximum du panier',
  'vouchers.min_cart_price': 'Prix minimum du panier',
  'vouchers.type': 'Type de bon',
  'vouchers.included_products': 'Produits inclus',
  'vouchers.excluded_products': 'Produits exclus',
  'vouchers.cart_fixed': 'Réduction fixe sur le panier',
  'vouchers.cart_percent': 'Réduction en pourcentage sur le panier',
  'vouchers.product_fixed': 'Réduction fixe sur le produit',
  'vouchers.product_percent': 'Réduction en pourcentage sur le produit',
  'voucher.edit': 'Modifier le bon de réduction',
};
